export default __webpack_public_path__ + "static/media/heart-pulse-line.ab4f61cf.svg";